<button
  *ngIf="canGoBack"
  mat-flat-button
  class="back-button"
  (keydown.enter)="goBack()"
  (keydown.space)="goBack()"
  (click)="goBack()">
  <span class="odilo-icon" aria-hidden="true">navigate_before</span>
  <span>{{ 'general.back' | translate }}</span>
</button>

<div class="view-more-wrapper" *ngIf="containerRecord">
  <div class="view-more__header__wrapper">
    <div class="view-more__header">
      <div class="view-more__header__toolbar" [tabIndex]="0" [attr.aria-label]="containerRecord.title">
        <div class="toolbar__info">
          <h2 [innerHTML]="containerRecord.title"></h2>
          <mat-chip-list class="elements">
            <mat-chip>{{ containerRecord.containerData.totalItems }} {{ 'general.items' | translate }}</mat-chip>
          </mat-chip-list>
        </div>
      </div>

      <div class="toolbar__actions">
        <app-record-interactions [record]="containerRecord" [rating]="containerRecordRating"></app-record-interactions>
      </div>

      <div class="view-more__header__description">
        <p [innerHTML]="containerRecord.description"></p>
      </div>
    </div>
  </div>

  <div class="wrapper" *ngIf="!rssItems.length && loadingMoreItems">
    <mat-spinner [diameter]="120"></mat-spinner>
  </div>

  <app-record-card-grid>
    <app-rss-item *ngFor="let item of rssItems" [containerRecord]="containerRecord" [item]="item"></app-rss-item>
  </app-record-card-grid>

  <div class="public-list__more" *ngIf="hasMoreItems && !loadingMoreItems" opacViewportObserver (visible)="loadMore()">
    <button mat-flat-button class="accent" (click)="loadMore()" [class.waiting]="loadingMoreItems">
      {{ 'results.suggestions.moreResults' | translate }}
    </button>
  </div>

  <div class="public-list__more" *ngIf="loadingMoreItems">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>
</div>
